import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Modal, Form, Alert } from "react-bootstrap";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Base_URL } from "../url";

const PunchInMaster = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Updated form state with validation
  const [formData, setFormData] = useState({
    userId: user?.userId || "",
    startDate: "",
    endDate: "",
    reason: ""
  });

  const [formErrors, setFormErrors] = useState({
    startDate: "",
    endDate: "",
    reason: ""
  });

  const openModal = () => {
    setFormData({
      userId: user?.userId || "",
      startDate: "",
      endDate: "",
      reason: ""
    });
    setFormErrors({
      startDate: "",
      endDate: "",
      reason: ""
    });
    setError("");
    setSuccess("");
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const validateForm = () => {
    const errors = {};
    const today = new Date().toISOString().split('T')[0];
    
    if (!formData.startDate) {
      errors.startDate = "Start date is required";
    } else if (formData.startDate < today) {
      errors.startDate = "Start date cannot be in the past";
    }
    
    if (!formData.endDate) {
      errors.endDate = "End date is required";
    } else if (formData.endDate < formData.startDate) {
      errors.endDate = "End date cannot be before start date";
    }
    
    if (!formData.reason.trim()) {
      errors.reason = "Reason is required";
    } else if (formData.reason.trim().length < 10) {
      errors.reason = "Reason must be at least 10 characters";
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

const handleSubmit = async () => {
  const payload = {
    userId: formData.userId,
    startDate: formData.startDate,
    endDate: formData.endDate,
    reason: formData.reason,
    leaveType: "WFH",   
    organisationId: user?.organisationId, 
  };

  console.log("Sending WFH Payload →", payload);

  try {
    const response = await axios.post(
      `${Base_URL}/Leave/ApplyWFH`,   
      payload,
      {
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json"
        }
      }
    );
    console.log("WFH Apply Response:", response.data);
    alert("WFH Request Sent Successfully!");
    closeModal();
  } catch (error) {
    console.error("Error applying for WFH:", error);
    alert("Failed to submit WFH request.");
  }
};

  const handlePostAttendance = () => {
    navigate("/attendance");
  };

  const handleRequestLeave = () => {
    navigate("/request-leave");
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Card
        style={{
          width: "24rem",
          borderRadius: "16px",
          padding: "1.5rem",
        }}
        className="shadow-lg text-center"
      >
        <Card.Body>
          <div className="d-flex flex-column gap-3">
            <Button variant="success" size="lg" onClick={handlePostAttendance}>
              Post Attendance
            </Button>

            <Button variant="warning" size="lg" onClick={() => alert("Break functionality coming soon!")}>
              Break
            </Button>

            <Button variant="primary" size="lg" onClick={handleRequestLeave}>
              Request Leave
            </Button>

            <Button variant="info" size="lg" onClick={openModal}>
              Work From Home
            </Button>
          </div>
        </Card.Body>
      </Card>

      {/* WFH Modal */}
      <Modal show={showModal} onHide={!loading ? closeModal : null} centered>
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Work From Home Request</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          
          <Form>
            {/* START DATE */}
            <Form.Group className="mb-3">
              <Form.Label>Start Date <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                isInvalid={!!formErrors.startDate}
                disabled={loading}
                min={new Date().toISOString().split('T')[0]}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.startDate}
              </Form.Control.Feedback>
            </Form.Group>

            {/* END DATE */}
            <Form.Group className="mb-3">
              <Form.Label>End Date <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                isInvalid={!!formErrors.endDate}
                disabled={loading}
                min={formData.startDate || new Date().toISOString().split('T')[0]}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.endDate}
              </Form.Control.Feedback>
            </Form.Group>

            {/* REASON */}
            <Form.Group className="mb-3">
              <Form.Label>Reason <span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                placeholder="Enter your reason..."
                isInvalid={!!formErrors.reason}
                disabled={loading}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.reason}
              </Form.Control.Feedback>
              <Form.Text className="text-muted">
                Minimum 10 characters required
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={closeModal}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Request"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PunchInMaster;